var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    d: "M15.425 7.433A6 6 0 004 10m1.078 3.432A6 6 0 0016 10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.098 9.413l1.768-1.768a.5.5 0 01.707.707l-2.121 2.121a.5.5 0 01-.707 0L1.624 8.352a.5.5 0 01.707-.707l1.767 1.768zm11.848 1.178l-1.828 1.705a.5.5 0 01-.682-.731l2.194-2.046a.5.5 0 01.706.025l2.046 2.194a.5.5 0 01-.73.682l-1.706-1.829z"
  }))));
};
export default SvgRefresh;